export { default } from './serviceCard';
